var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWiHere(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.24849 2.8C-0.221513 4.93 -0.391514 7.19 0.728486 9.59C1.68849 11.6 3.15849 13.6 5.11849 15.6C5.32849 15.82 5.56849 16.02 5.85849 16.19C6.33849 16.5 6.77849 16.65 7.16849 16.64C7.55849 16.63 7.98849 16.45 8.44849 16.1C8.57849 16 8.67849 15.91 8.74849 15.84C10.1185 14.6 11.4585 12.97 12.7485 10.96C13.3485 9.98 13.7685 8.92 14.0285 7.79C14.3485 6.36 14.1885 5.06 13.5485 3.88C12.1985 1.38 10.0585 0.09 7.14849 0H6.51849C6.31849 0.01 6.13849 0.0400004 5.97849 0.0800004C3.84849 0.41 2.27849 1.32 1.24849 2.8ZM7 10C8.65685 10 10 8.65685 10 7C10 5.34315 8.65685 4 7 4C5.34315 4 4 5.34315 4 7C4 8.65685 5.34315 10 7 10Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWiHere);
export default __webpack_public_path__ + "static/media/wi-here.1cb570fa9185708c116804a37165df16.svg";
export { ForwardRef as ReactComponent };